import React, { useState, useEffect, Fragment } from "react";

const useSkillCatTable = (
  skillCatData,
  handleDelSkillCat,
  handleEditSkillCat,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Skill Category", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = skillCatData.map((el) => {
      return {
        "Skill Category": el.skillCategoryName,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"    
              style={{ marginRight: "10px", cursor: "pointer" }}          
              onClick={() => {
                handleEditSkillCat(el, el.skillCategoryId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelSkillCat(el.skillCategoryId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    skillCatData,
    handleDelSkillCat,
    handleEditSkillCat,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useSkillCatTable;